export function hasRetainedPaidSubscription(subscription) {
  return subscription?.status === "past_due" && ["fun", "pro", "agent"].includes(subscription.planCode);
}

export function getRecoveryResumeTerms(recovery, locale = "en") {
  if (!recovery?.canResume || recovery.status !== "payment_failed" || !recovery.confirmationToken
    || !Number.isInteger(recovery.amountCents) || recovery.amountCents <= 0
    || !/^[A-Z]{3}$/.test(recovery.currency || "")
    || !["monthly", "annual"].includes(recovery.billingCycle)
    || !["immediate", "scheduled"].includes(recovery.resumeChargeTiming)) return null;
  const date = recovery.resumeChargeTiming === "scheduled" ? new Date(recovery.resumeChargeDate || "") : null;
  if (date && Number.isNaN(date.getTime())) return null;
  return {
    amount: new Intl.NumberFormat(locale, { style: "currency", currency: recovery.currency }).format(recovery.amountCents / 100),
    period: recovery.billingCycle === "annual" ? "year" : "month",
    timing: recovery.resumeChargeTiming,
    date: date ? new Intl.DateTimeFormat(locale, { dateStyle: "medium" }).format(date) : "",
  };
}

export function openCardUpdate(payload, navigate = (url) => window.location.assign(url)) {
  let destination;
  try { destination = new URL(payload?.url); } catch { throw new Error("Invalid card update destination"); }
  if (destination.protocol !== "https:"
    || !["www.payfast.co.za", "sandbox.payfast.co.za"].includes(destination.hostname)
    || !/^\/eng\/recurring\/update\/[^/]+$/.test(destination.pathname)
    || destination.username || destination.password || destination.port) {
    throw new Error("Invalid card update destination");
  }
  navigate(destination.href);
}
